module.exports = "<div data-watermark data-watermark-<%=position %>>\n<% if(typeof imageLink !== 'undefined') { %>\n<a target=_blank href=\"<%= imageLink %>\">\n<% } %>\n<img src=\"<%= imageUrl %>\">\n<% if(typeof imageLink !== 'undefined') { %>\n</a>\n<% } %>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/watermark/public/watermark.html
 ** module id = 144
 ** module chunks = 0
 **/